export default "__VITE_ASSET__83461f7f__"